module.exports = __webpack_public_path__ + "static/img/36.d72a93f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/36.jpg
// module id = 824e
// module chunks = 0